<template>
  <f7-block class="no-padding">
    <div class="content-tabla-marcajes">
      <!-- Cabecera Marcajes Trabajador -->
      <div
        v-if="selectedWorker != null"
        class="content-tabla-marcajes__header"
      >
        <span v-if="showSelectorConsultationDate">
          <UCDatePicker
            id="UCDateSelectedDate"
            title="Actividad del"
            :min-date="GetMinDateRecord()"
            :max-date="GetMaxDateRecord()"
            @onchange="DateChanged"
          />
        </span>
        <span v-else>
          Actividad de hoy
        </span>
        <img
          v-if="showCrudOptions"
          src="@/static/icons/ic_new.svg"
          @click="NavigateNewRecordForm()"
        >
      </div>

      <UCPreload :show="showPreloadRecords" />
      <div class="content-tabla-marcajes__list">
        <div
          v-for="marcaje in listRecordsWorker "
          :key="marcaje.Id"
          class="item-content-tabla-marcajes"
        >
          <span
            v-if="marcaje.ActividadProduccion != null"
            class="item-content-tabla-marcajes__name"
          >{{ marcaje.ActividadProduccion.Nombre }}</span>
          <div>
            <span
              v-if="!showTimeSeconds"
              class="item-text-x2"
            >
              {{ FormatHoursAndMinutes(marcaje.FechaHora) }}
            </span>
            <span v-else>
              {{ FormatHoursMinutesAndSeconds(marcaje.FechaHora) }}
            </span>
            <img
              v-if="(showCrudOptions || showCrudOptionsDelete) && !marcaje.noShow"
              src="@/static/icons/ic_delete.svg"
              @click="ConfirmRemoveRecords(marcaje)"
            >
          </div>
        </div> <!-- Fin registro -->
      </div>
    </div>
    <UCConfirmation ref="UCConfirmation" />
    <!-- POPUP DETALLE TRABAJADOR PARA NUEVO MARCAJE -->
    <f7-popup
      v-if="openNewRecordInPopup"
      class="new-mark-worker-popup"
      :opened="popupNewRecord"
      @popup:closed="popupNewRecord = false"
    >
      <f7-navbar
        sliding
        class="at-navbar secondary-navbar"
        title="Nuevo marcaje para trabajador"
      >
        <f7-nav-right>
          <f7-link
            popup-close
            icon="icon-close"
            @click="popupNewRecord = false"
          />
        </f7-nav-right>
      </f7-navbar>
      <div class="popup-new-record-workers">
        <PCNewWorkerRecord
          v-if="popupNewRecord"
          :default-selected-worker="selectedWorker"
          :default-selected-line="selectedProductionLine"
          template="P2"
          :restrict-day-marking="true"
          :reset-when-generating-new-record="false"
          :seconds-on-time-picker="true"
          @on-success="SuccessWorkerRecord"
          @on-cancel="popupNewRecord = false"
        />
      </div>
    </f7-popup>
  </f7-block>
</template>

<script>
import { useParamRef } from '@erpagroapp/params';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import APIErp from '@/js/services/APIErp';
import eventBus from '@/js/event-bus';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import { f7 } from 'framework7-vue';
import PCNewWorkerRecord from './PCNewWorkerRecord.vue';

export default {
  name: 'PCWorkerRecords',
  components: {
    UCPreload,
    UCConfirmation,
    UCDatePicker,
    PCNewWorkerRecord,
  },
  props: {
    selectedWorker: { type: Object, default: null },
    selectedProductionLine: { type: Object, default: null },
    showCrudOptions:
      { type: Boolean, default: true }, // Muestra el acceso a las operaciones CRUD sobre marcajes.
    showCrudOptionsDelete:
      { type: Boolean, default: true }, // Muestra el acceso a la operacion de eliminación de marcajes.
    restrictDayQuery: { type: Boolean, default: false }, /** Solo permite consultar marcajes del día actual, el anterior y  y el día siguiente  */
    showSelectorConsultationDate: { type: Boolean, default: false },
    openNewRecordInPopup: { type: Boolean, default: false },
    showTimeSeconds: { type: Boolean, default: false },
  },

  emits: [
    'on-success',
    'record-removed',
  ],

  data() {
    return {
      listRecordsWorker: [],
      showPreloadRecords: false,
      selectedRecord: null,
      consultationDate: null,
      popupNewRecord: false,
      noPermitirModificarMarcajePresencia: useParamRef('NoPermitirModificarMarcajePresencia'),
    };
  },
  watch: {
    selectedWorker(val) {
      if (val !== null) {
        this.GetWorkerRecords();
      }
      if (val === null) {
        this.listRecordsWorker = [];
      }
    },

  },
  created() {
    this.ActivateEvents();
    this.StartComponent();
  },
  unmounted() {
    this.DestroyComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.consultationDate = `${HiDateTimeSupport.FormatDateTime(new Date(), 'YYYY-MM-DD')}`;
      this.UpdateRecords();
    },
    DestroyComponent() {
      Log(this, this.DestroyComponent.name);
    },
    ActivateEvents() {
      Log(this, this.ActivateEvents.name);
      eventBus.on('new-record-done', () => {
        this.UpdateRecords();
      });
    },
    SuccessWorkerRecord() {
      this.popupNewRecord = false;
      this.$emit('on-success');
    },
    DisableEvents() {
      Log(this, this.DisableEvents.name);
      eventBus.off('new-record-done');
    },
    UpdateRecords() {
      Log(this, this.UpdateRecords.name);
      this.listRecordsWorker = [];
      this.GetWorkerRecords();
    },

    FormatHoursAndMinutes(stringDateTime) {
      return HiDateTimeSupport.FormatDateTime(stringDateTime, 'HH:mm');
    },
    FormatHoursMinutesAndSeconds(stringDateTime) {
      return HiDateTimeSupport.FormatDateTime(stringDateTime, 'HH:mm:ss');
    },
    ConfirmRemoveRecords(objRecord) {
      Log(this, this.ConfirmRemoveRecords.name);
      this.selectedRecord = objRecord;
      this.$refs.UCConfirmation.create('Eliminar marcaje trabajador', 'El marcaje seleccionado del trabajador será eliminado de forma permanente. ¿Estás seguro que quieres eliminar el marcaje?', this.RemoveWorkerRecords);
      this.$refs.UCConfirmation.show();
    },
    NavigateNewRecordForm() {
      Log(this, this.NavigateNewRecordForm.name);
      if (this.openNewRecordInPopup) {
        this.popupNewRecord = true;
      } else {
        f7.views.main.router.navigate('/production/workerRecords/newWorkerRecord');
      }
    },
    GetMaxDateRecord() {
      if (this.restrictDayQuery) {
        return HiDateTimeSupport.AddHoursAndMinutes(new Date(), 24, 0);
      }
      return new Date(8640000000000000);
    },
    GetMinDateRecord() {
      if (this.restrictDayQuery) {
        return HiDateTimeSupport.AddHoursAndMinutes(new Date(), -48, 0);
      }
      return new Date(-8640000000000000);
    },
    DateChanged(newDate) {
      Log(this, this.DateChanged.name);
      this.consultationDate = `${HiDateTimeSupport.FormatDateTime(newDate, 'YYYY-MM-DD')}`;
      this.UpdateRecords();
    },

    GetWorkerRecords() {
      Log(this, this.GetWorkerRecords.name);
      if (this.selectedWorker == null) {
        return;
      }
      const self = this;
      self.showPreloadRecords = true;
      /*
      APIErp.callWorkerRecords(this.selectedWorker.Id, true).then((result) => {
        self.listRecordsWorker = result.data;
        self.showPreloadRecords = false;
      }).catch((error) => {
        self.showPreloadRecords = false;
        LogError(this, this.GetWorkerRecords.name, error);
      });
      */
      APIErp.callWorkerRecordsXDate(this.selectedWorker.Id, this.consultationDate).then((result) => {
        self.listRecordsWorker = result.data;
        self.listRecordsWorker.forEach((element) => {
          element.noShow = false;
          if (this.noPermitirModificarMarcajePresencia && element.ActividadProduccion.Codigo === 'PRE') {
            element.noShow = true;
          }
        });
        self.showPreloadRecords = false;
      }).catch((error) => {
        self.showPreloadRecords = false;
        LogError(this, this.GetWorkerRecords.name, error);
      });
    },
    RemoveWorkerRecords() {
      Log(this, this.RemoveWorkerRecords.name);
      if (this.selectedWorker == null) {
        HiNotification.Toast(true, 'Es necesario seleccionar un marcaje.');
        return;
      }
      const self = this;
      HiDialog.Preloader(true, 'Eliminando Marcaje');
      APIErp.callRemoveWorkerRecord(
        this.selectedWorker.Id,
        this.selectedRecord.Id,
        this.selectedRecord.ActividadProduccion.Id,
      )
        .then(() => {
          HiDialog.Preloader(false);
          self.UpdateRecords();
          this.$emit('record-removed', this.selectedRecord);
        }).catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Toast('Ocurrió un error al eliminar el marcaje del trabajador');
          LogError(this, this.RemoveWorkerRecords.name, error);
          self.UpdateRecords();
        });
    },
  },
};
</script>

<style lang="scss">
.content-tabla-marcajes {
  overflow: scroll;
  position: relative;
  height: calc(var(--f7-popup-tablet-height) - 210px); /* Cuidado con este 210px puede fallan en otras alturas */
  padding: 0 20px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: var(--his-oliva);
      font-weight: 500;
      font-size: 14px;
    }

    img {
      width: 32px;
      height: 32px;
    }
  }

  &__list {
    .item-content-tabla-marcajes {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 0;
      border-bottom: 1px solid var(--his-disabled);

      &__name {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }

      span {
        font-size: 18px;
        font-weight: 500;
        line-height: 21px;
        color: var(--his-teal-green);
      }

      >div {
        display: flex;
        align-items: center;

        span {
          color: var(--his-orange);
          font-size: 14px;
          font-weight: 500;
        }

        img {
          padding-left: 30px;
        }
      }
    }
  }
}

.new-mark-worker-popup {
  overflow-y: auto;
}
</style>
